import Animation from './Animation';
import './Levelstep.css';
import { play } from '../../../SoundManager';

export default class Levelstep extends Animation {

	constructor (master) {

		super(master, 0);
		this.loadAudio("heartbeatsoft");
	}

	run () {

		var el = document.querySelector("#game-entity-player .game-entity-afterimage");
		if (el && !el.classList.contains("levelstep-animation")) {
			el.classList.add("levelstep-animation");
			setTimeout(() => el.classList.remove("levelstep-animation"), 1000);
		}
	}
}